// NAME -> available publicly
export const featureFlags = {
  SALES_LOG_V2: true,
  DELIVERY_CALENDAR_V2: true,
  INSIGHTS: true,
  USERS_V2: true,
  NEW_SALE_V2: true,
  MULTI_STORE_DASHBOARD: false,
  FUNDED_DEAL_DISPLAY: false,
  NEW_SALES_LOG_UI: false,
  SETTINGS_V2: true,
  DUE_BILLS_V2: true,
  LEADS_V2: true,
  CONFIGURABLE_FINANCE_PRODUCTS: false,
  FINANCE_REPORTS: false,
  // CarTracked Engine — off by default. Flip to true to expose the nav entry,
  // page, and API route. Gated everywhere so it carries no risk while disabled.
  CARTRACKED_ENGINE: false,
};

export const SalesLogFeatureFlags = {
  NEW_SALES_LOG_UI: "NEW_SALES_LOG_UI",
  FUNDED_DEAL_DISPLAY: "FUNDED_DEAL_DISPLAY",
};

export const NavFeatureFlags = {
  SALES_LOG_V2: "SALES_LOG_V2",
  DELIVERY_CALENDAR_V2: "DELIVERY_CALENDAR_V2",
  INSIGHTS: "INSIGHTS",
  USERS_V2: "USERS_V2",
  NEW_SALE_V2: "NEW_SALE_V2",
  MULTI_STORE_DASHBOARD: "MULTI_STORE_DASHBOARD",
  FUNDED_DEAL_DISPLAY: "FUNDED_DEAL_DISPLAY",
  SETTINGS_V2: "SETTINGS_V2",
  DUE_BILLS_V2: "DUE_BILLS_V2",
  LEADS_V2: "LEADS_V2",
  FINANCE_REPORTS: "FINANCE_REPORTS",
  CARTRACKED_ENGINE: "CARTRACKED_ENGINE",
};

export const Permissions = {
  ADMINISTRATIVE_ACCESS: "ADMINISTRATIVE_ACCESS",
  SUPPORT_ACCESS: "SUPPORT_ACCESS",
  ACCESS_DASHBOARD: "ACCESS_DASHBOARD",
  ACCESS_CONFIGURATION: "ACCESS_CONFIGURATION",
  VIEW_DASHBOARD_FULL: "VIEW_DASHBOARD_FULL",
  VIEW_DASHBOARD_PARTIAL: "VIEW_DASHBOARD_PARTIAL",
  VIEW_SALES_LOG: "VIEW_SALES_LOG",
  VIEW_SALES_LOG_FULL: "VIEW_SALES_LOG_FULL",
  VIEW_SALES_LOG_PARTIAL: "VIEW_SALES_LOG_PARTIAL",
  VIEW_DELIVERY_SCHEDULE: "VIEW_DELIVERY_SCHEDULE",
  VIEW_OWN_GROSS: "VIEW_OWN_GROSS",
  VIEW_OWN_BACK_GROSS: "VIEW_OWN_BACK_GROSS",
  VIEW_OTHERS_GROSS: "VIEW_OTHERS_GROSS",
  VIEW_OWN_TARGETS: "VIEW_OWN_TARGETS",
  VIEW_OTHERS_TARGETS: "VIEW_OTHERS_TARGETS",
  VIEW_CHANGE_LOG: "VIEW_CHANGE_LOG",
  ADD_COMMENTS: "ADD_COMMENTS",
  EDIT_FRONT_GROSS: "EDIT_FRONT_GROSS",
  EDIT_BACK_GROSS: "EDIT_BACK_GROSS",
  EDIT_SALE_DEAL_INFO: "EDIT_SALE_DEAL_INFO",
  EDIT_SALE_VEHICLE_INFO: "EDIT_SALE_VEHICLE_INFO",
  EDIT_SALE_PEOPLE: "EDIT_SALE_PEOPLE",
  EDIT_SALE_TRADE_INFO: "EDIT_SALE_TRADE_INFO",
  EDIT_SALE_FINANCE: "EDIT_SALE_FINANCE",
  CREATE_NEW_SALE: "CREATE_NEW_SALE",
  CREATE_USERS: "CREATE_USERS",
  REMOVE_USERS: "REMOVE_USERS",
  VIEW_USERS: "VIEW_USERS",
  RESET_PASSWORD_OTHERS: "RESET_PASSWORD_OTHERS",
  CHANGE_USER_PERMISSIONS: "CHANGE_USER_PERMISSIONS",
  SET_USER_TARGETS: "SET_USER_TARGETS",
  CONFIGURE_GOALS: "CONFIGURE_GOALS",
  ACCESS_REPORTS: "ACCESS_REPORTS",
  ACCESS_DUEBILLS: "ACCESS_DUEBILLS",
  CREATE_DUEBILL: "CREATE_DUEBILL",
  RECEIVE_DAILY_RECAP: "RECEIVE_DAILY_RECAP",
  VIEW_FILE_UPLOAD: "VIEW_FILE_UPLOAD",
  VIEW_OTHER_CUSTOMERS: "VIEW_OTHER_CUSTOMERS",
  VIEW_LEADS: "VIEW_LEADS",
  EDIT_LEADS: "EDIT_LEADS",
} as const;
